import { protectedApiClientV2 } from 'api/support/baseApiClients';
import type {
  CompanyTrendStatRaw,
  DashboardOverview,
  Granularity,
  TopCompaniesOrder,
  TopCompanyStatRaw
} from 'pages/dashboard/models';

// mWork365.WebApi Statistics module, reached through YARP `/api` (protectedApiClientV2 root).
// Routes follow the doc-08 scope prefix: /superadmin/... for cross-company superadmin endpoints.
const BASE = '/superadmin/statistics/dashboard';

const superadminStatisticsClient = {
  getOverview: async (from: string, to: string, granularity: Granularity) => {
    const result = await protectedApiClientV2.get<DashboardOverview>(`${BASE}/overview`, {
      params: { from, to, granularity }
    });
    return result.data;
  },
  getTopCompanies: async (
    from: string,
    to: string,
    limit = 10,
    orderBy: TopCompaniesOrder = 'coreActivity'
  ) => {
    const result = await protectedApiClientV2.get<{ companies: TopCompanyStatRaw[] }>(
      `${BASE}/top-companies`,
      { params: { from, to, limit, orderBy } }
    );
    return result.data.companies;
  },
  getCompanyTrends: async (from: string, to: string) => {
    const result = await protectedApiClientV2.get<{ companies: CompanyTrendStatRaw[] }>(
      `${BASE}/company-trends`,
      { params: { from, to } }
    );
    return result.data.companies;
  }
};

export default superadminStatisticsClient;
